var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGuides(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.749 3.94736V26.6099C18.4762 26.6368 18.2008 26.5968 17.9469 26.4932L9.05111 23.1682C8.79536 23.0716 8.52168 23.0318 8.24902 23.0515V0.389031C8.5219 0.362054 8.79723 0.402103 9.05111 0.505698L17.9469 3.8307C18.2027 3.92727 18.4764 3.96708 18.749 3.94736Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M7.47614 0.578255C7.71614 0.457463 7.9804 0.392645 8.24906 0.388672V23.0512C7.98063 23.0569 7.71674 23.1216 7.47614 23.2408L2.48864 25.7491C2.26554 25.8615 2.01729 25.9147 1.7677 25.9037C1.51811 25.8926 1.27555 25.8176 1.06329 25.6858C0.851017 25.5541 0.676155 25.37 0.555468 25.1513C0.43478 24.9325 0.372314 24.6864 0.374059 24.4366V5.94492C0.374347 5.4023 0.526 4.87051 0.811966 4.40936C1.09793 3.94821 1.50687 3.57597 1.99281 3.33451L7.47614 0.578255Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M26.624 2.56227V21.0539C26.6237 21.5966 26.4721 22.1283 26.1861 22.5895C25.9001 23.0506 25.4912 23.4229 25.0053 23.6643L19.5219 26.4206C19.2819 26.5414 19.0177 26.6062 18.749 26.6102V3.94768C19.0175 3.942 19.2813 3.87727 19.5219 3.7581L24.5094 1.24977C24.7325 1.13734 24.9808 1.08411 25.2304 1.09518C25.48 1.10626 25.7225 1.18127 25.9348 1.31303C26.1471 1.44478 26.3219 1.62885 26.4426 1.8476C26.5633 2.06635 26.6258 2.31244 26.624 2.56227Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuides);
export default __webpack_public_path__ + "static/media/Guides.9907dc7bac56e7ae2f7efde18e158a4b.svg";
export { ForwardRef as ReactComponent };